import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/data/content";

export const Products = () => {
  return (
    <section id="solutions" data-testid="products-section" className="py-20 sm:py-24 md:py-32 relative scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12 sm:mb-16">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-4">Nos outils du digital</p>
          <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            Des solutions modernes, conçues en interne.
          </h2>
          <p className="mt-5 text-muted-foreground text-base leading-relaxed">
            Du support physique connecté au pilotage de votre présence en ligne,
            on couvre toute la chaîne de votre notoriété locale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {PRODUCTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={p.span}
              >
                <Link
                  to={`/solutions/${p.slug}`}
                  data-testid={`product-card-${i}`}
                  className="group relative flex flex-col h-full bg-surface border border-border p-7 sm:p-8 overflow-hidden hover:border-accent/50 transition-colors"
                >
                  {p.image && (
                    <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity">
                      <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/85 to-surface/45" />
                    </div>
                  )}
                  <div className="relative z-10 flex flex-col h-full">
                    <div className="flex items-center justify-between mb-6">
                      <div className="w-12 h-12 flex items-center justify-center border border-accent/40 bg-accent/5 text-accent">
                        <Icon size={22} />
                      </div>
                      <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground border border-border px-3 py-1">
                        {p.tag}
                      </span>
                    </div>
                    <h3 className="font-heading font-semibold text-xl sm:text-2xl mb-3">{p.title}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed max-w-md">{p.desc}</p>
                    <span className="mt-6 inline-flex items-center gap-1.5 text-sm text-accent font-medium">
                      En savoir plus
                      <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
